import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommonDataStore } from './common-data.store';
import { Currency } from '../../models/common-data/currency';

@Injectable()
export class CurrencyResolver implements Resolve<any> {

    constructor(private commonDataStore: CommonDataStore) { }

    resolve(): Observable<Currency[]> {
        return this.commonDataStore.loadCurrencies();
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/common-data/currency.resolver.ts